type RegistrationUiOnlyFields = {
    terms_of_service?: boolean
}

/** Убирает поля только для UI: terms_of_service — отдельное согласие, на бэкенд не уходит. */
export const omitRegistrationUiFields = <T extends RegistrationUiOnlyFields>(
    data: T
): Omit<T, keyof RegistrationUiOnlyFields> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { terms_of_service, ...apiData } = data
    return apiData
}
